export const TermType = {
  ABRBCI: "ABRBCI",
  SBRHVI: "SBRHVI",
  FINISH: "FINISH"
};
